import { HttpHeaders, HttpParams } from '@angular/common/http'

export class HttpOptionsFactory {
  headers: HttpHeaders
  observe: string = 'body' // 'body' | 'events' | 'response'
  params?: HttpParams
  reportProgress?: boolean
  responseType: string = 'json' // 'arraybuffer' | 'blob' | 'json' | 'text'
  withCredentials?: boolean

  constructor() {
    this.headers = new HttpHeaders()
    this.observe = 'body'
    this.responseType = 'json'
  }

  addContentType(contentType: string): HttpOptionsFactory {
    this.headers = this.headers.append('Content-Type', contentType)
    return this
  }

  addContentTypeJson(): HttpOptionsFactory {
    return this.addContentType('application/json')
  }

  addAccept(accept: string): HttpOptionsFactory {
    this.headers = this.headers.append('Accept', accept)
    return this
  }

  addAcceptJson(): HttpOptionsFactory {
    return this.addAccept('application/json')
  }

  // not working :-(
  // addResponseType(responseType: string): HttpOptionsFactory {
  //     this.responseType = responseType;
  //     return this;
  // }

  // addObserveOption(): HttpOptionsFactory {
  //     this.observe = 'response';
  //     return this;
  // }

  build() {
    return {
      headers: this.headers
    }
  }

  // not working :-(
  // buildNew() {
  //     return this;
  // }

  buildWithObserveOption() {
    return {
      observe: 'response' as 'response',
      headers: this.headers
    }
  }
}
